var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEntre({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_5954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 29.375V13.625M14.375 29.375V13.625M25.5 18.125V25.125C25.5 25.9404 25.5 26.3481 25.6205 26.6697C25.7812 27.0985 26.0895 27.4392 26.4774 27.6168C26.7684 27.75 27.1372 27.75 27.875 27.75C28.6128 27.75 28.9816 27.75 29.2726 27.6168C29.6605 27.4392 29.9688 27.0985 30.1295 26.6697C30.25 26.3481 30.25 25.9404 30.25 25.125V18.125C30.25 17.3096 30.25 16.9019 30.1295 16.5803C29.9688 16.1515 29.6605 15.8108 29.2726 15.6332C28.9816 15.5 28.6128 15.5 27.875 15.5C27.1372 15.5 26.7684 15.5 26.4774 15.6332C26.0895 15.8108 25.7812 16.1515 25.6205 16.5803C25.5 16.9019 25.5 17.3096 25.5 18.125Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_5954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEntre);
export default __webpack_public_path__ + "static/media/NoEntre.6cc377592fe8c4f682cb0e27b8c43b84.svg";
export { ForwardRef as ReactComponent };